enum BudgetModes {
  IMPRESSIONS = 'I',
  BUDGET = 'B',
}

export default BudgetModes;
